import React, { useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../../assets/styles/createproduct.css";
import "../../assets/styles/distributors.css";
import dist1 from "../../assets/images/categ1.png"
import { useViewDistributorUsers } from "../../hooks/distributor/distributer.users.view";
import { useStoreDistributorUser } from "../../hooks/distributor/distributor.user.store";
import { useRemoveDistributerUser } from "../../hooks/distributor/distributer.user.delete"
import toast from "react-hot-toast";
import countryList from "react-select-country-list";
import Select from "react-select";
import Swal from "sweetalert2";


export const ViewDistributor = () => {
  const { id: routeCompanyId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { distributor } = location.state || {};

  const distributorId = routeCompanyId || distributor?.id || distributor?._id;
  const storeDistributorUser = useStoreDistributorUser();
  const removeDistributorUser = useRemoveDistributerUser();
  const [showAddUserForm, setShowAddUserForm] = useState(false);
  const [newUser, setNewUser] = useState({
    profilePicture: null,
    profilePicturePreview: null,
    email: "",
    phone: "",
    contactPerson: "",
    designation: "",
    country: null,
    password: "",
    verificationIntervalDays: 60,
  });
  const countryOptions = useMemo(() => countryList().getData(), []);

  const {
    data: usersData,
    isLoading: usersLoading,
    error: usersError,
    refetch: refetchUsers,
  } = useViewDistributorUsers(distributorId, !!distributorId);

  const usersList = usersData?.data?.map(user => ({
    id: user._id,
    email: user.email,
    phone: user.phone,
    contactPerson: user.contactPerson,
    designation: user.designation,
    profilePicture: user.profilePicture ? `${process.env.REACT_APP_BASE_IMAGE}${user.profilePicture}` : dist1,
    invitationAcceptedDate: user.approval?.invitationAcceptAt
      ? new Date(user.approval.invitationAcceptAt).toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
      : 'N/A',
    accessStatus: user.accessStatus,
    verificationIntervalDays: user.verificationIntervalDays,
  })) || [];


  const readUserProfilePic = (input) => {
    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = function (e) {
        setNewUser((prev) => ({
          ...prev,
          profilePicture: input.files[0],
          profilePicturePreview: e.target.result,
        }));
      };
      reader.readAsDataURL(input.files[0]);
    }
  };

  const resetAddUserForm = () => {
    setNewUser({
      profilePicture: null,
      profilePicturePreview: null,
      email: "",
      phone: "",
      contactPerson: "",
      designation: "",
      country: null,
      password: "",
      verificationIntervalDays: 60,
    });
  };

  const editDistributorUser = (userId) => {
    navigate(`/distributors/EditUsers/${userId}`, { state: { userId } });
  };

  const handleDeleteDistributorUser = async (userId, contactPerson) => {
    const result = await Swal.fire({
      title: "Delete Distributor User?",
      text: `Are you sure you want to delete "${contactPerson || "this user"}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    removeDistributorUser.mutate(userId, {
      onSuccess: async () => {
        toast.success("Distributor user deleted successfully.");
        await refetchUsers();
      },
      onError: (error) => {
        toast.error(
          error?.response?.data?.message || "Failed to delete distributor user."
        );
      },
    });
  };

  const handleCreateDistributorUser = async (e) => {
    e.preventDefault();

    if (!distributorId) {
      toast.error("Company ID is missing in the URL.");
      return;
    }

    if (!newUser.email || !newUser.phone || !newUser.contactPerson || !newUser.password) {
      toast.error("Please fill in all required user fields");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("companyName", distributorId);
      formData.append("email", newUser.email);
      formData.append("phone", newUser.phone);
      formData.append("contactPerson", newUser.contactPerson);
      formData.append("designation", newUser.designation || "");
      formData.append("country", newUser.country?.label || "");
      formData.append("loginAuth[password]", newUser.password);
      formData.append('otpVerification[verificationIntervalDays]', newUser.verificationIntervalDays);


      if (newUser.profilePicture) {
        formData.append("profilePicture", newUser.profilePicture);
      }

      await storeDistributorUser.mutateAsync(formData);
      toast.success("Distributor user created successfully");
      resetAddUserForm();
      setShowAddUserForm(false);
      await refetchUsers();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to create distributor user");
    }
  };

  return (
    <>
      <div className="body">
        <div className="view-distributor-card">
          <div className="view-distributor-header">
            <h3 className="view-distributor-title">Distributor Profile</h3>
            <div style={{ display: "flex", gap: "10px" }}>
              <button
                className="commonButton"
                onClick={() => setShowAddUserForm((prev) => !prev)}
                disabled={!distributorId}
              >
                {showAddUserForm ? "Cancel Add User" : "Add Distributor User"}
              </button>
              <button
                className="commonButton view-distributor-back-btn"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </div>

          {!distributorId && (
            <p style={{ color: "#dc3545", marginBottom: "14px" }}>
              Company ID not found in route params. Open this page from a valid distributor URL.
            </p>
          )}

          {showAddUserForm && (
            <form onSubmit={handleCreateDistributorUser} style={{ marginBottom: "20px" }}>
              <div
                style={{
                  background: "#fff",
                  padding: "20px",
                  borderRadius: "8px",
                  border: "1px solid #d9e3f0",
                }}
              >
                <h4 style={{ marginTop: 0, marginBottom: "16px", color: "#004996" }}>
                  Add Distributor User
                </h4>

                <div className="form-headerr">
                  <div className="image-upload-section">
                    <label style={{ fontWeight: "bold", marginBottom: "10px", display: "block" }}>
                      Upload Profile Picture:
                    </label>
                    <div className="avatar-upload" style={{ margin: "0" }}>
                      <div className="avatar-edit">
                        <input
                          type="file"
                          id="viewDistributorUserImageUpload"
                          accept=".png, .jpg, .jpeg"
                          onChange={(e) => readUserProfilePic(e.target)}
                        />
                        <label htmlFor="viewDistributorUserImageUpload"></label>
                      </div>
                      <div className="avatar-preview">
                        <div
                          id="viewDistributorUserImagePreview"
                          style={{ backgroundImage: `url(${newUser.profilePicturePreview})` }}
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="name">
                    <label style={{ fontWeight: "bold" }}>
                      Contact Person Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      value={newUser.contactPerson}
                      onChange={(e) => setNewUser({ ...newUser, contactPerson: e.target.value })}
                      placeholder="Enter full name..."
                      required
                      style={{ width: "100%", marginTop: "10px", padding: "12px" }}
                    />
                  </div>

                  <div className="name">
                    <label style={{ fontWeight: "bold" }}>
                      Email <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="email"
                      value={newUser.email}
                      onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                      placeholder="Enter email address..."
                      required
                      style={{ width: "100%", marginTop: "10px", padding: "12px" }}
                    />
                  </div>

                  <div className="name">
                    <label style={{ fontWeight: "bold" }}>
                      Phone <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="tel"
                      value={newUser.phone}
                      onChange={(e) => setNewUser({ ...newUser, phone: e.target.value })}
                      placeholder="Enter phone number..."
                      required
                      style={{ width: "100%", marginTop: "10px", padding: "12px" }}
                    />
                  </div>

                  <div className="name">
                    <label style={{ fontWeight: "bold" }}>
                      Password <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="password"
                      value={newUser.password}
                      onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
                      placeholder="Enter login password..."
                      required
                      style={{ width: "100%", marginTop: "10px", padding: "12px" }}
                    />
                  </div>

                  <div className="name">
                    <label style={{ fontWeight: "bold" }}>Designation</label>
                    <input
                      type="text"
                      value={newUser.designation}
                      onChange={(e) => setNewUser({ ...newUser, designation: e.target.value })}
                      placeholder="Enter designation..."
                      style={{ width: "100%", marginTop: "10px", padding: "12px" }}
                    />
                  </div>

                  <div className="name">
                    <label style={{ fontWeight: "bold" }}>Country</label>
                    <Select
                      options={countryOptions}
                      value={newUser.country}
                      onChange={(value) => setNewUser({ ...newUser, country: value })}
                      placeholder="Select country..."
                      styles={{
                        control: (base) => ({
                          ...base,
                          marginTop: "10px",
                          padding: "4px",
                        }),
                      }}
                    />
                  </div>
                  <div className="name">
                    <label style={{ fontWeight: 'bold' }}>
                      OTP Verification Days
                    </label>
                    <input
                      type="number"
                      value={newUser.verificationIntervalDays}
                      onChange={(e) => setNewUser({ ...newUser, verificationIntervalDays: e.target.value })}
                      placeholder="Enter number of days..."
                      min="1"
                      style={{ width: "100%", marginTop: "10px", padding: "12px" }}
                    />
                    <small style={{ color: '#666', display: 'block', marginTop: '5px' }}>
                      Number of days before OTP verification is required
                    </small>
                  </div>

                </div>

                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px" }}>
                  <button
                    type="submit"
                    className="commonButton"
                    style={{ background: "#28a745" }}
                    disabled={storeDistributorUser.isPending}
                  >
                    {storeDistributorUser.isPending ? "Saving..." : "Save User"}
                  </button>
                </div>
              </div>
            </form>
          )}

          <div className="view-distributor-image-section">
            <img
              className="view-distributor-avatar"
              src={distributor?.logo ? `${process.env.REACT_APP_BASE_IMAGE}/${distributor.logo}` : dist1}
              alt="Distributor Logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = dist1;
              }}
            />
          </div>

          <div className="view-distributor-grid">
            <div className="view-field">
              <label className="field-label">Company Name : </label>
              <p className="field-value">{distributor?.companyName || "N/A"}</p>
            </div>

            <div className="view-field">
              <label className="field-label">Company ID : </label>
              <p className="field-value">{distributorId || "N/A"}</p>
            </div>

            <div className="view-field">
              <label className="field-label">Website : </label>
              <p className="field-value">
                {distributor?.website ? (
                  <a
                    href={`https://${distributor.website}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#007bff" }}
                  >
                    {distributor.website}
                  </a>
                ) : (
                  "N/A"
                )}
              </p>
            </div>

            <div className="view-field">
              <label className="field-label">Country : </label>
              <p className="field-value">{distributor?.country || "N/A"}</p>
            </div>
          </div>

          <div className="distributor-table-container">
            {usersLoading ? (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <p>Loading users...</p>
              </div>
            ) : usersError ? (
              <div style={{ textAlign: 'center', padding: '20px', color: 'red' }}>
                <p>Error loading users: {usersError.message}</p>
              </div>
            ) : usersList.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '20px' }}>
                <p>No users found for this distributor</p>
              </div>
            ) : (
              <table className="distributor-table">
                <thead>
                  <tr className="distributor-table-head-tr">
                    <th className="distributor-th">Profile Picture</th>
                    <th className="distributor-th">Email</th>
                    <th className="distributor-th">Phone</th>
                    <th className="distributor-th">Contact Person</th>
                    <th className="distributor-th">Designation</th>
                    <th className="distributor-th">Invitation Accept</th>
                    <th className="distributor-th">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {usersList.map((user) => (
                    <tr key={user.id} className="distributor-tr">
                      <td className="distributor-td">
                        <img
                          src={user.profilePicture}
                          alt="User"
                          className="distributor-td-img"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = dist1;
                          }}
                        />
                      </td>
                      <td className="distributor-td">{user.email}</td>
                      <td className="distributor-td">
                        <a href={`tel:${user.phone}`} className="distributor-link">
                          {user.phone}
                        </a>
                      </td>
                      <td className="distributor-td distributor-text-secondary">
                        {user.contactPerson}
                      </td>
                      <td className="distributor-td distributor-text-secondary">
                        {user.designation}
                      </td>
                      <td className="distributor-td distributor-text-secondary">
                        {user.invitationAcceptedDate}
                      </td>
                      <td className="distributor-td">
                        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                          <button
                            className="commonButton"
                            onClick={() => editDistributorUser(user.id)}
                          >
                            Edit
                          </button>
                          <button
                            className="commonButton"
                            style={{ background: "#dc3545" }}
                            onClick={() =>
                              handleDeleteDistributorUser(user.id, user.contactPerson)
                            }
                            disabled={removeDistributorUser.isPending}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          {/* Pagination removed as usePagination is not defined */}
          {/* <div style={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div> */}
        </div>
      </div>
    </>
  );
};
